import { I18nComponente } from "@/types/gerais"

export const CalendarioDeAtividadesi18n: I18nComponente = {
  "pt-BR": {
    hoje: "hoje",
    mes: "mês",
    semana: "semana",
    dia: "dia",
    projetosSelecionados: "projetos selecionados",
    buscarPorNome: "buscar por nome",
    lancarAtividades: "lançar atividades",
    lancarAtividadesPlanejadas: "lançar atividades planejadas",
    iniciarAtividadeNaoPlanejada: "iniciar atividade não planejada",
    travarPeriodo: "travar período",
    filtros: "filtros",
    ocorrencias: "ocorrências",
    atividadeMuitoLonga: "atividade muito longa",
    atividadeMuitoCurta: "atividade muito curta",
    atividadeNaoPlanejada: "atividade não planejada",
    atividadeSemOcorrencias: "atividade sem ocorrências",
    filtroDeOcorrenciasLeganda1: "Os itens podem ser marcados para efetuar o filtro das atividades com ocorrências.",
    filtroDeOcorrenciasLeganda2: "Os grupos acima são mutuamente exclusivos, ou seja, só é possível marcar um de cada vez",
    tiposDeAtividades: "tipos de atividade",
    profissionais: "profissionais",
    projetos: "projetos",
    atividades: "atividades",
    todosOsProjetos: "Todos os projetos",
    gruposDeProjetos: "grupos de projetos",
    erroAoBuscarGruposDeProjetos: "Erro ao buscar grupos de projetos",
    ocorreuUmErroAoCarregarCalendario: "Ocorreu um erro ao carregar o calendário",
    usuarioNaoPossuiPermissaoParaIniciarAtividade: "Usuário não possui permissão para iniciar a atividade",
    atividadeIniciadaComSucesso: "Atividade iniciada com sucesso",
    calendarioEstaSendoAtualizado: "O calendário esta sendo atualizado",
    ocorreuUmErroAoIniciarAtividade: "Ocorreu um erro ao iniciar a atividade",
    atividadeFinalizadaComSucesso: "Atividade finalizada com sucesso",
    tenteNovamenteMaisTarde: "Tente novamente mais tarde.",
    ocorreuUmErroAoFinalizarAtividade: "Ocorreu um erro ao finalizar a atividade",
    atributosComValoresInvalidos: "Atributos com valores inválidos",
    obrigatorioPreencherAtributos: "É obrigatório preencher todos os atributos com valores válidos",
  },
  "es-CO": {
    hoje: "hoy",
    mes: "mes",
    semana: "semana",
    dia: "día",
    projetosSelecionados: "proyectos seleccionados",
    buscarPorNome: "buscar por nombre",
    lancarAtividades: "ingresar actividad",
    lancarAtividadesPlanejadas: "ingresar actividades planeadas",
    iniciarAtividadeNaoPlanejada: "iniciar actividad no planeada",
    travarPeriodo: "congelar período",
    filtros: "filtros",
    ocorrencias: "incidentes",
    atividadeMuitoLonga: "actividad muy larga",
    atividadeMuitoCurta: "actividad muy corta",
    atividadeNaoPlanejada: "actividad no planeada",
    atividadeSemOcorrencias: "actividad sin incidentes",
    filtroDeOcorrenciasLeganda1: "Los elementos se pueden marcar para filtrar las actividades con incidentes.",
    filtroDeOcorrenciasLeganda2: "Solo puedes marcar un grupo a la vez",
    tiposDeAtividades: "tipos de actividad",
    profissionais: "profesionales",
    projetos: "proyectos",
    atividades: "actividades",
    todosOsProjetos: "Todos los proyectos",
    gruposDeProjetos: "grupos de proyectos",
    erroAoBuscarGruposDeProjetos: "Error al buscar grupos de proyectos",
    ocorreuUmErroAoCarregarCalendario: "Se produjo un error al cargar el calendario",
    usuarioNaoPossuiPermissaoParaIniciarAtividade: "El usuario no tiene permiso para iniciar la actividad",
    atividadeIniciadaComSucesso: "Actividad iniciada con éxito",
    calendarioEstaSendoAtualizado: "El calendario se está actualizando",
    ocorreuUmErroAoIniciarAtividade: "Se produjo un error al iniciar la actividad",
    atividadeFinalizadaComSucesso: "Actividad finalizada con éxito",
    tenteNovamenteMaisTarde: "Inténtalo de nuevo más tarde.",
    ocorreuUmErroAoFinalizarAtividade: "Se produjo un error al finalizar la actividad",
    atributosComValoresInvalidos: "Atributos con valores inválidos",
    obrigatorioPreencherAtributos: "Es obligatorio completar todos los atributos con valores válidos",
  }
}
